import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { times } from 'lodash';
import React from 'react';

export default ({ n }) =>
  times(n, () => <FontAwesomeIcon icon={['far', 'star']} />);
